import React from 'react'
import { MID_TRADE_VIEW_HISTORICAL, MID_TRADE_VIEW_INCOMING, MID_TRADE_VIEW_INITIATED } from 'selectors/midTradeEventsSelectors'

export type MidTradeEventsProviderValue =
  | typeof MID_TRADE_VIEW_HISTORICAL
  | typeof MID_TRADE_VIEW_INITIATED
  | typeof MID_TRADE_VIEW_INCOMING
  | undefined

export const MidTradeEventsViewContext = React.createContext<MidTradeEventsProviderValue>(undefined)

export const useMidTradeEventsView = () => React.useContext(MidTradeEventsViewContext)
